import { useContext } from 'preact/hooks';
import { useTranslationBase } from '@uw/common-components';
import { ApplicationContext } from 'services/use-application-setup';

export const useTranslation = () => {
  const { language, setLanguage } = useContext(ApplicationContext);

  const translate = useTranslationBase(language);

  return {
    translate,
    setLanguage,
  };
};
